import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

const Material = [
  MatIconModule,
];
@Component({
  selector: 'eq-alert-success',
  standalone: true,
  imports: [
    CommonModule,
    ...Material
  ],
  templateUrl: './alert-success.component.html',
  styleUrl: './alert-success.component.scss',
})
export class AlertSuccessComponent {
  @Input('initLabel') initLabel: string = '';
  @Input('label') label: string = '';
}
